import { render, staticRenderFns } from "./Knowledges.vue?vue&type=template&id=fac57866"
import script from "./Knowledges.vue?vue&type=script&lang=js"
export * from "./Knowledges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports